import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://d02d8c048325713949897a01295d94c0@o4509700534960128.ingest.de.sentry.io/4509700538957904',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/.*\.nospen\.com\/api/,
    /^https:\/\/api\.nospen\.com/,
  ],
  // Session Replay
  replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  // Setting this option to true will send default PII data to Sentry.
  sendDefaultPii: true,
  environment: process.env.NODE_ENV || 'development',
  // Release tracking - this helps with crash-free session tracking
  release: `nospen-web@${process.env.REACT_APP_VERSION || '1.0.0'}`,
  // Additional options
  beforeSend(event) {
    // Filter out development errors - don't send to Sentry in development
    if (process.env.NODE_ENV === 'development') {
      console.log('Sentry Event (blocked in development):', event);
      return null; // Prevent sending to Sentry in development
    }
    return event;
  },
  // Set user context
  initialScope: {
    tags: {
      component: 'web-app',
    },
  },
});
// Utility functions for Sentry
export const setUserContext = (user: {
  id?: string;
  email?: string;
  username?: string;
}) => {
  Sentry.setUser(user);
};

export const clearUserContext = () => {
  Sentry.setUser(null);
};

export const captureException = (
  error: Error,
  context?: Record<string, any>,
) => {
  if (context) {
    Sentry.withScope((scope) => {
      Object.keys(context).forEach((key) => {
        scope.setContext(key, context[key]);
      });
      Sentry.captureException(error);
    });
  } else {
    Sentry.captureException(error);
  }
};

export const captureMessage = (
  message: string,
  level: 'info' | 'warning' | 'error' = 'info',
) => {
  Sentry.captureMessage(message, level);
};

export const addBreadcrumb = (
  message: string,
  category?: string,
  data?: Record<string, any>,
) => {
  Sentry.addBreadcrumb({
    message,
    category: category || 'custom',
    data,
    level: 'info',
  });
};
